//! @ngInject
export function newPhysicianModalCtrl(
    $rootScope,
    $scope,
    DatabaseApi,
    data,
    physiciansService,
    $uibModalInstance,
    toaster
) {
    const physicians = DatabaseApi.physicians();

    function initialize() {
        $scope.form = {};
        if (data) {
            $scope.data = {
                ...data,
                fax: data.fax?.replace('+1', '') ?? null,
                fax2: data.fax2?.replace('+1', '') ?? null,
            };
        } else {
            $scope.data = {
                address: null,
                licenseNumber: null,
                phone: null,
                fax: null,
                fax2: null,
                emailAddress: null,
                contactNotes: null,
            }
        }
    }

    $scope.adddressChange = () => {
        $scope.data.address = $scope.data.address.formatted_address;
    };

    $scope.submitForm = function () {
        console.log("$scope.form", $scope.form);
        if ($scope.form.fax.$invalid) {
            toaster.pop('warning', "Invalid fax number");
            return;
        }
        if ($scope.form.fax2.$invalid) {
            toaster.pop('warning', "Invalid fax2 number");
            return;
        }
        if ($scope.form.$invalid) {
            return;
        }

        const physicianRequest = preparePhysicianRequest();
        if ($scope.data.id) {
            physiciansService.editPhysician($scope.data.id, physicianRequest)
                .then(function (res) {
                    toaster.pop('success', "Physician updated successfully");
                    $uibModalInstance.close($scope.data);
                }, function (err) {
                    toaster.pop('error', "Something went wrong", "Could not updated physician");
                });
        } else {
            const existingPhysicianWithNPI = physicians.find(p => p.npi === $scope.data.npi);
            if (existingPhysicianWithNPI) {
                return toaster.pop('warning', "This physician already exists in the list (NPI)");
            }

            physiciansService.createPhysician(physicianRequest).then(function (res) {
                toaster.pop('success', "Physician created successfully");
                $uibModalInstance.close(res.data.physician);
            }, function (err) {
                toaster.pop('error', "Something went wrong", "could not create a new physician");
            });
        }
    };

    function preparePhysicianRequest() {
        const body = {
            ...$scope.data,
            fax: $scope.data.fax && $rootScope.isOnboardingAgency ? `+1${$scope.data.fax}` : $scope.data.fax,
            fax2: $scope.data.fax2 && $rootScope.isOnboardingAgency ? `+1${$scope.data.fax2}` : $scope.data.fax2,
        };

        return body;
    }

    $scope.closeModal = function () {
        $uibModalInstance.close('ok');
    };

    initialize();
};
